import { Injectable } from '@angular/core';

import { ChatDraft } from '../models/chat.state.interface';

@Injectable({
  providedIn: 'root',
})
export class ChatStorageService {
  private readonly storageKey = 'chat-drafts';

  getDraftsFromStorage(): ChatDraft[] {
    try {
      const saved = localStorage.getItem(this.storageKey);
      return saved ? JSON.parse(saved) : [];
    } catch (error) {
      console.error('Error loading chat drafts from localStorage:', error);
      return [];
    }
  }

  setDraftsToStorage(drafts: ChatDraft[]): void {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(drafts));
    } catch (error) {
      console.error('Error saving chat drafts to localStorage:', error);
    }
  }

  clearDraftsFromStorage(): void {
    try {
      localStorage.removeItem(this.storageKey);
    } catch (error) {
      console.error('Error clearing chat drafts from localStorage:', error);
    }
  }

  setSelectedDraftToStorage(draft: ChatDraft): void {
    try {
      const drafts = this.getDraftsFromStorage();
      const existingIndex = drafts.findIndex(d => d.threadId === draft.threadId);
      if (existingIndex >= 0) {
        drafts[existingIndex] = draft;
      } else {
        drafts.push(draft);
      }
      this.setDraftsToStorage(drafts);
    } catch (error) {
      console.error('Error saving chat draft to localStorage:', error);
    }
  }

  clearSelectedDraftFromStorage(threadId: string): void {
    try {
      const drafts = this.getDraftsFromStorage();
      const filteredDrafts = drafts.filter(d => d.threadId !== threadId);
      this.setDraftsToStorage(filteredDrafts);
    } catch (error) {
      console.error('Error clearing chat draft by thread ID from localStorage:', error);
    }
  }
}
